import { create } from "zustand";
import type { AlexandriaCard } from "./useAlexandriaSections";

// Cross-surface handoff. When a consumer taps "Ask Triton" on an
// Alexandria card, we stash the card here, navigate to /triton, and
// TritonChat reads + consumes the pending card on mount.

interface TritonHandoffState {
  pendingCard: AlexandriaCard | null;
  setPendingCard: (card: AlexandriaCard | null) => void;
  consumePendingCard: () => AlexandriaCard | null;
}

export const useTritonHandoff = create<TritonHandoffState>((set, get) => ({
  pendingCard: null,
  setPendingCard: (card) => set({ pendingCard: card }),
  consumePendingCard: () => {
    const card = get().pendingCard;
    set({ pendingCard: null });
    return card;
  },
}));


export function tritonPrefillFromCard(card: AlexandriaCard): string {
  // Concierge-warm, factual prompt per LS-SPEC-32. The model decides
  // the next step; we just hand over a tight question grounded in the
  // card.
  const at = card.geography_label ? ` in ${card.geography_label}` : "";
  const verb =
    card.card_type === "hotel" || card.card_type === "package"
      ? "Tell me more about"
      : card.card_type === "salon"
        ? "What can you tell me about"
        : "Walk me through";
  return `${verb} "${card.title}"${at}.`;
}
